import { render, staticRenderFns } from "./make-cover-dailog.vue?vue&type=template&id=104f47d4&scoped=true&"
import script from "./make-cover-dailog.vue?vue&type=script&lang=js&"
export * from "./make-cover-dailog.vue?vue&type=script&lang=js&"
import style0 from "./make-cover-dailog.vue?vue&type=style&index=0&id=104f47d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104f47d4",
  null
  
)

export default component.exports